<template>
    <div
        :class="['visual-canvas', modify]"
        :style="[{'width': width},{'height': height}]"
      >
            <svg v-if="!isFlat"
             class="visual-canvas__svg"
             :viewBox="[`0 0 ${renderSize.width} ${renderSize.height}`]"
             preserveAspectRatio="xMidYMid slice"
             ref="svg"
        >
            <image x="0" y="0" width="100%" height="100%" :xlink:href=render.link></image>

            <rect
                class="visual-canvas__overlay" width="100%" height="100%"
                :fill-opacity="overlay"
                mask="url(#visual-canvas__hole)"
            >
            </rect>

            <path
                v-for="element in elements" :key="element.id"
                :class="['visual-canvas__path', {'is-booked': element.isBooked}]"
                :id=element.id
                :d=element.path
                :link=element.link
                ref="masks"
                :fill="[element.fill ? element.fill : $appOptions.fill]"
                @mouseover="mouseOverHandler(element.id, element.link, $event)"
                @mousemove="mouseMoveHandler"
                @mouseleave="mouseLeaveHandler(element.id)"
                @click="clickHandler(element.link)"
            >
            </path>


            <defs>
                <mask id="visual-canvas__hole">
                    <rect fill="white" width="100%" height="100%"></rect>
                    <path v-for="element in elements" :key="element.id" :d=element.path></path>
                </mask>
            </defs>
        </svg>

            <svg v-if="isFlat"
             class="visual-canvas__svg"
             :viewBox="[`0 0 ${renderSize.width} ${renderSize.height}`]"
             preserveAspectRatio="xMidYMid"
             ref="svg"
        >
            <!-- Обязательно оставить, порядок важден для положения масок -->
            <image x="0" y="0" width="100%" height="100%" :xlink:href=render.link></image>

            <path
                v-for="element in elements" :key="element.id"
                :class="['visual-canvas__path visual-canvas__path-floor', {
                    'is-booked': element.tooltip.status === 'booked',
                    'is-sold': element.tooltip.status === 'sold',
                    'is-not-sale': element.tooltip.status === 'notSale'
                }]"
                :id=element.id
                :d=element.path
                :link=element.link
                ref="masks"
                :fill="[element.fill ? element.fill : $appOptions.fill]"
                @mouseover="mouseOverHandler(element.id, element.link, $event)"
                @mousemove="mouseMoveHandler"
                @mouseleave="mouseLeaveHandler"
                @click="clickHandler(element.link, element.tooltip.status, $event)"
            >
            </path>
        </svg>
        <slot name="pointer"></slot>
        <slot name="infrastructure"></slot>
        <slot name="panorama"></slot>
    </div>
</template>

<style lang='scss'>
    @import "./Canvas.scss";
</style>

<script>
import {mapGetters} from 'vuex';
import Observer from 'common/scripts/observer';
import Utils from 'common/scripts/utils';

const observer = new Observer();

export default {
    props: ['modify'],

    data() {
        return {
            overlay   : this.$appOptions.overlay.default,
            width     : '',
            height    : '',
            clickCount: 0
        };
    },

    computed: {
        ...mapGetters({
            renderSize: 'GET_CANVAS_SIZE',
            render    : 'GET_RENDER',
            rotate    : 'GET_ROTATE',
            elements  : 'GET_ELEMENTS',
            dataStep  : 'GET_DATA_STEP',
            pointers  : 'GET_POINTERS',
            slice     : 'GET_SLICE'
        }),

        isFlat() {
            return !this.slice;
        }
    },

    watch: {
        rotate() {
            this.setCanvasSize();
        }
    },

    beforeCreate() {
        observer.unsubscribe('clicknextPanel');
    },

    created() {
        this.setOverlayOpacity();
        this.bindEvents();
        this.subscribes();
        this.setCanvasSize();
    },

    methods: {
        setCanvasSize() {
            const params = {
                width : `${100}%`,
                height: `${100}%`,
                scale : Number(this.render.scale) || 1
            };
            const widthRatio = window.screen.height * 16 / 9;

            if (!Utils.isBreakpoint(0, 960)) {
                this.width = params.width;
                this.height = params.height;

                return;
            }

            if (this.dataStep.step === 'flat') {
                if (window.outerWidth < widthRatio) {
                    const scale = 1.5;

                    this.width = `${window.screen.width * scale}px`;
                    this.height = `${window.screen.height * scale}px`;

                    if (this.render.position && (this.render.position !== '0' || this.render.position !== 0)) {
                        this.scrollToPosition();
                    } else {
                        this.scrollToCenter();
                    }
                }

                return;
            }

            // если ширина экрана не позволяет вписать полностью рендер, то тянем его в пропорции 16/9
            if (window.outerWidth < widthRatio) {
                this.width = `${widthRatio * params.scale}px`;
                this.height = `${window.screen.height * params.scale}px`;
                if (this.render.position && (this.render.position !== '0' || this.render.position !== 0)) {
                    this.scrollToPosition();
                } else {
                    this.scrollToCenter();
                }
            } else {
                this.width = params.width;
                this.height = params.height;
            }
        },

        scrollToCenter() {
            let renderPosition = parseFloat(this.width.replace(/[^\d.]/ig, '')) / 2;
            const scrollFrame = document.querySelector('.visual');

            renderPosition = renderPosition - (window.outerWidth / 2);

            this.$nextTick(() => {
                scrollFrame.scrollTo({
                    left    : renderPosition,
                    behavior: 'smooth'
                });
            });
        },

        scrollToPosition() {
            if (!this.render.position) {
                return;
            }

            const renderPosition = Number(this.render.position);
            const scrollFrame = document.querySelector('.visual');

            this.$nextTick(() => {
                scrollFrame.scrollTo({
                    left    : renderPosition,
                    behavior: 'smooth'
                });
            });
        },

        bindEvents() {
            window.addEventListener('resize', this.setCanvasSize.bind(this));
        },

        subscribes() {
            observer.subscribe('clicknextPanel', (link) => {
                this.route(link);
            });
        },

        mouseOverHandler(id, link, event) {
            this.overlay = this.$appOptions.overlay.hover;

            if (this.dataStep.step === 'floor' && (this.pointers && this.pointers.length)) {
                observer.publish('setPointerHover', id);
            }
            // this.movingPath(event);

            if (Utils.isBreakpoint(0, 1280)) {
                observer.publish('mouseoverPanel', {
                    id,
                    link,
                    event,
                    elements: this.elements,
                    type    : 'flats'
                });
            } else {
                observer.publish('mouseoverTooltip', {
                    id,
                    event,
                    elements: this.elements,
                    type    : 'flats'
                });
            }
        },

        mouseMoveHandler(event) {
            if (!Utils.isBreakpoint(0, 1280)) {
                observer.publish('mousemoveTooltip', event);
            }
        },

        mouseLeaveHandler(id) {
            this.overlay = this.dataStep.step === 'floor' ?
                this.$appOptions.overlay.floor :
                this.$appOptions.overlay.default;

            if (this.dataStep.step === 'floor' && (this.pointers && this.pointers.length)) {
                observer.publish('removePointerHover', id);
            }

            if (Utils.isBreakpoint(0, 1280)) {
                observer.publish('mouseleavePanel');
                this.clickCount = 0;
            } else {
                observer.publish('mouseleaveTooltip');
            }
        },

        clickHandler(link, element, event) {
            if (Utils.isBreakpoint(0, 1280)) {
                this.clickCount = this.clickCount + 1;
                if (this.clickCount % 2 === 0) {
                    this.route(link);
                }
            } else if (element === 'sold' || element === 'notSale' || element === 'booked') {
                event.preventDefault();
            } else {
                observer.publish('mouseclickTooltip');
                this.route(link);
            }
        },

        movingPath(event) {
            const target = event.currentTarget;
            const svg = this.$refs.svg;

            event.currentTarget.style.display = 'none';

            svg.insertAdjacentHTML('afterbegin', target.outerHTML);
        },

        route(link) {
            if (this.dataStep.step === 'flat') {
                window.location = link;
            } else {
                this.$router.push(link);
            }
        },

        setOverlayOpacity() {
            this.overlay = this.dataStep.step === 'floor' ?
                this.$appOptions.overlay.floor :
                this.$appOptions.overlay.default;
        }
    }
};
</script>
